module.exports = __webpack_public_path__ + "static/media/last.73832f61.svg";